import './HomeLoggedOut.css'

import Header from '../Header/Header'

import useMediaQuery from '../../hooks/useMediaQuery'

import TopPart from './TopPart'
import MobileTopPart from './MobileTopPart'
import AccordionItem from '../AccordionToggle/AccordionToggle'

import { useState } from 'react'

const HomeLoggedOut = () => {
    const isMobile = useMediaQuery('(max-width:1024px)')
    const [active, setActive] = useState(null)

    const handleToggle = index => {
        if (active === index) {
            setActive(null)
        } else {
            setActive(index)
        }
    }

    const faqs = [
        {
            id: 1,
            accordionTitle: 'Ταμειακή υπηρεσία',
            accordionContent: (
                <div>
                    <p>Ταμειακή Υπηρεσία Τηλ.: 22453 – 60142</p>
                    <p>E-mail: tameio@karpathos.gr</p>
                    <p>
                        Ώρες Εξυπηρέτησης Κοινού: Δευτέρα έως Παρασκευή 08:00 -
                        13:30 (για συναλλαγές μόνο μέσω POS με χρεωστική ή
                        πιστωτική κάρτα){' '}
                    </p>
                    <p>
                        Το Τμήμα Ταμειακής Υπηρεσίας είναι υπεύθυνο για την
                        είσπραξη και την διαχείριση των εσόδων και των εξόδων
                        του Δήμου Καρπάθου.
                    </p>
                </div>
            ),
        },
        {
            id: 3,
            accordionTitle: 'Έσοδα',
            accordionContent: (
                <div>
                    <p>Έσοδα Τηλ: 22453 – 60145</p>
                    <p>E-mail: esoda@karpathos.gr</p>
                    <p>
                        Ώρες Εξυπηρέτησης Κοινού: Δευτέρα έως Παρασκευή: 08:00 -
                        13:00 (για πάσης φύσεως πληρωμές) Δευτέρα έως Παρασκευή:
                        08:00 - 14:00 (για πληροφορίες){' '}
                    </p>
                    <p>
                        {' '}
                        Το Τμήμα Εσόδων είναι υπεύθυνο για την έκδοση αδειών
                        άσκησης υπαιθρίων επαγγελμάτων και κατάληψης
                        κοινοχρήστων χώρων, καθώς και τον έλεγχο φορολογικών
                        στοιχείων και την επίλυση οικονομικών διαφορών. Στις
                        αρμοδιότητές του συγκαταλέγονται, επίσης, ο καθορισμός
                        του ύψους δικαιωμάτων, τελών και φόρων, η διαχείριση της
                        δημοτικής περιουσίας (μίσθωση, εκμίσθωση και εκποίηση
                        ακινήτων) και η είσπραξη των τελών ακίνητης περιουσίας
                        (ΤΑΠ).
                    </p>
                </div>
            ),
        },
    ]

    return (
        <>
            {isMobile ? null : (
                <Header
                    includeLogo={true}
                    withBorder={false}
                    includeButtons={true}
                />
            )}

            {isMobile ? <MobileTopPart /> : <TopPart />}

            <div className="w-full flex justify-center items-center bg-white p-12 flex-col">
                <div className="bg-aqua aqua-box p-8 text-center text-white font-bold max-w-5xl text-lg">
                    <p>
                        Η πλατφόρμα GovPay του Δήμου Καρπάθου είναι σε πιλοτική
                        λειτουργία. Οι πολίτες και οι φορείς μπορούν να
                        συνδεθούν μέσω taxisnet, για να προχωρήσουν στην πληρωμή
                        των οφειλών τους.
                    </p>
                </div>
                <p className="text-center text-2xl py-12 font-bold my-3">
                    Μπορείτε να πληρώσετε με ασφάλεια και ηλεκτρονικά
                </p>
                <div className="w-full max-w-3xl mb-8">
                    <ul className="list-disc text-xl flex flex-col gap-3">
                        <li>Τέλη Παρεπιδημούντων</li>
                        <li>Τέλη χρήσης κοινόχρηστων χώρων</li>
                        <li>Λογαριασμός Ύδρευσης</li>
                        <li>
                            Μισθώματα ακινήτων, βοσκοτόπων, λατομείων και
                            δασικών εκτάσεων
                        </li>
                        <li>Δικαίωμα ανακομιδής και χρήσης οστεοφυλακίου</li>
                        <li>Αγορά τάφου</li>
                        <li>Κλήσεις Κ.Ο.Κ.</li>
                    </ul>
                </div>
                <div className="container mx-auto px-16 py-8 max-w-[60%]">
                    <h1 className="text-2xl font-bold mb-6 text-primary text-center">
                        Δημοτικές Υπηρεσίες
                    </h1>
                    {faqs.map((faq, index) => (
                        <AccordionItem
                            key={index}
                            active={active}
                            handleToggle={handleToggle}
                            faq={faq}
                        />
                    ))}
                </div>
            </div>
        </>
    )
}

export default HomeLoggedOut
